import Fallback from "app/components/Fallback";
import React from "react";

const Tasks = React.lazy(() =>
  import("app/modules/task-management/pages/Task/TasksPage")
);

const TaskReport = React.lazy(() =>
  import("app/modules/task-management/pages/TaskReport/TaskReportPage")
);

export const TasksPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Tasks {...props} />
  </React.Suspense>
);

export const TaskReportPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <TaskReport {...props} />
  </React.Suspense>
);